<template>
    <div>
        <div id="control" class="mb-4">
            <div class="d-flex">
                <select v-model="year" class="form-select me-2 select-small w-25">
                    <option v-for="yy in years" :key="yy" :value="yy">{{ yy }}</option>
                </select>
                <select v-model="month" class="form-select me-2 select-small w-25">
                    <option v-for="mm in months" :key="mm" :value="mm">{{ mm }}</option>
                </select>
                <button @click="fetchData" class="btn btn-primary">表示・更新</button>
            </div>


            <div>表示チャンネル</div>
            <div class="form-check form-switch me-2 my-2">
                <div class="d-flex me-8">
                    <input class="form-check-input" type="checkbox" v-model="showOkopure" id="showOkopureToggle">
                    <label class="form-check-label" for="showOkopureToggle">おこさまぷれ～と。</label>
                </div>
                <div class="d-flex me-8">
                    <input class="form-check-input" type="checkbox" v-model="showOkawari" id="showOkawariToggle">
                    <label class="form-check-label" for="showOkawariToggle">おかわりぷれ～と。</label>
                </div>
                <div class="d-flex me-8">
                    <input class="form-check-input" type="checkbox" v-model="showFr2pon" id="showFr2ponToggle">
                    <label class="form-check-label" for="showFr2ponToggle">FR2PON (ふる～つぽんち。含む)</label>
                </div>
                <div class="d-flex me-8">
                    <input class="form-check-input" type="checkbox" v-model="showStmlt" id="showStmltToggle">
                    <label class="form-check-label" for="showStmltToggle">ステミレイツ</label>
                </div>
                <div class="d-flex me-8">
                    <input class="form-check-input" type="checkbox" v-model="showBadivy" id="showBadivyToggle">
                    <label class="form-check-label" for="showBadivyToggle">BAD IVY</label>
                </div>
                <div class="d-flex me-8">
                    <input class="form-check-input" type="checkbox" v-model="showChippi" id="showChippiToggle">
                    <label class="form-check-label" for="showChippiToggle">ちっぴ</label>
                </div>
                <div class="d-flex me-8">
                    <input class="form-check-input" type="checkbox" v-model="showSunnyCircle" id="showSunnyCircleToggle">
                    <label class="form-check-label" for="showSunnyCircleToggle">サニサー</label>
                </div>
            </div>
            <div>その他オプション</div>
            <div class="form-check form-switch me-2 my-2">
                <input class="form-check-input" type="checkbox" v-model="showShorts" id="showShortsToggle">
                <label class="form-check-label" for="showShortsToggle">Shortを含む (タイトルに#Shortsがあるかないかのみで判別しているので、OFFでも混ざります)</label>
            </div>
        </div>

        <div v-if="loading"><img src="/loading.gif">Loading...</div>
        <div v-else-if="error">{{ error }}</div>
        <div v-else-if="sortedMultipulChannelVideosByDate.length > 0">
            <div class="d-flex justify-content-between mx-4 my-4">
                <button class="btn btn-secondary" @click="previousMonth">◀ 前の月</button>
                <button class="btn btn-secondary" @click="nextMonth">次の月 ▶</button>
            </div>

            <div class="container">
                <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
                    <template v-for="(item, index) in sortedMultipulChannelVideosByDate" :key="index">
                        <div id="showManagement" class="col" v-if="showShorts || !item.isShort">
                            <VideoCard :video="item" />
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div v-else>
            <p>
                情報取得前です。表示ボタンを押してデータリクエストしてください。<br>
                ボタンを押しても表示が切り替わらない場合は、その設定で動画データが無いか、
                対象の動画情報が未設定のため、運営者が対応するまでお待ち下さい。<br>                
            </p>
        </div>
        <div>
            <button class="btn btn-secondary mx-4 my-4" @click="previousMonth">◀ 前の月</button>
            <button class="btn btn-secondary mx-4 my-4 float-end" @click="nextMonth">次の月 ▶</button>
        </div>
    </div>
</template>

<script>
import { ref, onMounted, computed, watch } from 'vue';
import VideoCard from './VideoCard.vue';
import Cookies from 'js-cookie';

const apiUrl = process.env.VUE_APP_API_URL;

export default {
    name: 'VideoCards',
    components: {
        VideoCard
    },
    setup() {
        const loading = ref(false);
        const error = ref(null);
        const year = ref(2017);
        const month = ref(12);

        // APIから取得したデータの格納
        const videoList = ref({});
        // 年の選択肢を定義
        const years = Array.from({ length: new Date().getFullYear() - 2017 + 1 }, (_, index) => 2017 + index);
        // 月の選択肢を定義
        const months = Array.from({ length: 12 }, (_, index) => index + 1);

        // toggleSwitchの状態を保持する
        const showShorts = ref(false);
        const showOkopure = ref(true);
        const showFr2pon = ref(false);
        const showStmlt = ref(false);
        const showBadivy = ref(false);
        const showOkawari = ref(false);
        const showChippi = ref(false);
        const showSunnyCircle = ref(false);

        // 選択された年月の月単位の中で、選択されたチャンネルの動画を日付順で格納する
        const sortedMultipulChannelVideosByDate = computed(() => {
            const videos = [];
            if (showOkopure.value && videoList.value.okopure?.[year.value]?.[month.value]?.result) {
               videos.push(...videoList.value.okopure[year.value][month.value].result);
            }
            if (showOkawari.value && videoList.value.okawari?.[year.value]?.[month.value]?.result) {
                videos.push(...videoList.value.okawari[year.value][month.value].result);
            }
            if (showFr2pon.value && videoList.value.fr2pon?.[year.value]?.[month.value]?.result) {
                videos.push(...videoList.value.fr2pon[year.value][month.value].result);
            }
            if (showStmlt.value && videoList.value.stmlt?.[year.value]?.[month.value]?.result) {
                videos.push(...videoList.value.stmlt[year.value][month.value].result);
            }
            if (showBadivy.value && videoList.value.badivy?.[year.value]?.[month.value]?.result) {
                videos.push(...videoList.value.badivy[year.value][month.value].result);
            }
            if (showChippi.value && videoList.value.chippi?.[year.value]?.[month.value]?.result) {
                videos.push(...videoList.value.chippi[year.value][month.value].result);
            }
            if (showSunnyCircle.value && videoList.value.sunnycircle?.[year.value]?.[month.value]?.result) {
                videos.push(...videoList.value.sunnycircle[year.value][month.value].result);
            }
            const sortedVideos = videos.sort((a, b) => new Date(a.date) - new Date(b.date));

            return sortedVideos;
        });
        
        // エポック秒からYYYYMMDD HH:mm へ変換する関数
        const formatDate = (epoch) => {
            const date = new Date(epoch * 1000);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}`;
        };

        const fetchData = async () => {
            var channelList = ["okopure", "fr2pon", "stmlt", "badivy", "okawari", "chippi", "sunnycircle"];
            var availableChannel = [showOkopure.value, showFr2pon.value, showStmlt.value, showBadivy.value, showOkawari.value, showChippi.value, showSunnyCircle.value];

            for(var i = 0; i < availableChannel.length; i++){
                // 有効状態じゃなければスキップ
                if(!availableChannel[i]){
                    continue;
                }
                if (videoList.value[channelList[i]] && videoList.value[channelList[i]][year.value] && videoList.value[channelList[i]][year.value][month.value]?.result) {
                    // データが存在しない場合、または result が未定義の場合は取得済みのデータのため再取得しない
                    // return;
                    continue;
                }
                
                console.log("try to fetch video data");
                try {
                    loading.value = true;
                    const response = await fetch(`${apiUrl}/data?channel=${channelList[i]}&year=${year.value}&month=${month.value}`);
                    if (!response.ok) {
                        throw new Error('Failed to fetch data');
                    }
                    const responseJsonData = await response.json();

                    // データがなければ初期化
                    if (!videoList.value[channelList[i]]) {
                        videoList.value[channelList[i]] = {};
                    }
                    if (!videoList.value[channelList[i]][year.value]) {
                        videoList.value[channelList[i]][year.value] = {};
                    }

                    // エポック秒を日時に変換し、データに追加
                    const sortedVideos = responseJsonData.result.sort((a, b) => a.publishedAtEpoch - b.publishedAtEpoch);
                    sortedVideos.forEach(video => {
                        video.date = formatDate(video.publishedAtEpoch);
                        video.isShort = video.title.toLowerCase().includes('#short');
                        video.channel = channelList[i];
                    });
                    // ここでチャンネルの月単位データは日付順にソートされるが、チャンネル単位であり、複数チャンネルがまとまってはいない
                    // そのため、別途 computed ですべてのチャンネルを混ぜた状態で日付順にソートする
                    videoList.value[channelList[i]][year.value][month.value] = {
                        result: sortedVideos
                    };

                } catch (err) {
                    console.error("Error", err.message);
                    error.value = "データのロードでエラーが発生しました";
                } finally {
                    loading.value = false;
                }
            }
        };

        const previousMonth = () => {
            if (month.value === 1 && 2017 < year.value) {
                month.value = 12;
                year.value -= 1;
            } else if(year.value == 2017 && month.value == 12) {
                // この条件より過去のデータは存在しないため
                return;
            } else {
                month.value -= 1;
            }
            fetchData();
        };

        const nextMonth = () => {
            const currentYear = new Date().getFullYear();
            const currentMonth = new Date().getMonth() + 1;

            if (month.value === 12) {
                month.value = 1;
                year.value += 1;
            }else if(year.value === currentYear && month.value === currentMonth) {
                // これ以上未来のデータは無いので移動させない
                return;
            } else {
                month.value += 1;
            }
            fetchData();
        };

        watch(
            () => ({
                shorts: showShorts.value,
                okopure: showOkopure.value,
                fr2pon: showFr2pon.value,
                stmlt: showStmlt.value,
                badivy: showBadivy.value,
                okawari: showOkawari.value,
                chippi: showChippi.value,
                sunnycircle: showSunnyCircle.value,
                year: year.value,
                month: month.value
            }),
            (newVal, oldVal) => {
                console.log("トグル変化を検知:", oldVal, "=>", newVal);
                Cookies.set('toggleState', JSON.stringify(newVal), { expires: 7 });
            },
            { deep: true } // オブジェクトのネストを監視する場合
        );

        onMounted(() => {
            try{
                // Cookieからトグルの状態を読み込む
                const savedToggleState = Cookies.get('toggleState')
                if(savedToggleState !== undefined){
                    const toggleStateObj = JSON.parse(savedToggleState);
                    showShorts.value = toggleStateObj.shorts ?? false;
                    showOkopure.value = toggleStateObj.okopure ?? true;
                    showFr2pon.value = toggleStateObj.fr2pon ?? false;
                    showStmlt.value = toggleStateObj.stmlt ?? false;
                    showBadivy.value = toggleStateObj.badivy ?? false;
                    showOkawari.value = toggleStateObj.okawari ?? false;
                    showChippi.value = toggleStateObj.chippi ?? false;
                    showSunnyCircle.value = toggleStateObj.sunnycircle ?? false;
                    year.value = toggleStateObj.year ?? 2017;
                    month.value = toggleStateObj.month ?? 12;
                }
            }catch(e){
                console.log("cookieからのToggle状態の読み込みに失敗しました");
            }
            fetchData();
        });

        return {
            loading,
            error,
            year,
            month,
            showShorts,
            showOkopure,
            showFr2pon,
            showStmlt,
            showBadivy,
            showOkawari,
            showChippi,
            showSunnyCircle,
            videoList,
            years,
            months,
            fetchData,
            previousMonth,
            nextMonth,
            sortedMultipulChannelVideosByDate
        };
    }
};
</script>

<style scoped>
.halfsize-box{
    width: 50%;
}
</style>